/**
 * The Geology icon: the Estwing rock pick's silhouette, traced from its photo (Rahman, 27 Oct 2026: "it needs a geopick
 * as an icon", then "not like a death sickle, be careful, just copy the eastwing sillouette exactly"). Filled, as a
 * silhouette is: the square poll at the top right, the head a broad wedge to the point at the left, and the steel neck
 * stepping out into the grip down to the right, with its rounded butt. One drawing for the Widget Host's tray, the main
 * rail and the panel.
 */
export const GEOLOGY_ICON_SVG =
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">' +
  '<path fill="currentColor" stroke="currentColor" stroke-width="0.4" stroke-linejoin="round" d="' +
  // the head: the poll's top and its square face, then the wedge's underside to the point and its top edge back
  'M11 0.77 13 2.2 11.65 4.16 8.84 8.44Q5.9 10.6 2.1 14.45 6 7 11 0.77Z' +
  // the handle: the steel neck, the step out to the grip, the grip to its rounded butt
  'M9.6 6.4 11 5.7 13.1 9.9 13.9 10.2 19.9 20.9Q20.4 22.6 18.9 22.95 17.7 23.1 17.3 22.2L11.25 11 11.75 10.9Z' +
  '"/></svg>';
